import React, { Fragment } from "react";
import { useNavigate } from "react-router-dom";
import Header from "../../Common/Header";
import Footer from "../../Common/Footer";
import "./StatusLayout.scss";

const normalizeActions = (footerActions) => {
  if (!footerActions) return [];
  if (Array.isArray(footerActions)) {
    return footerActions.filter(Boolean);
  }
  return [footerActions];
};

const StatusLayout = ({ title, description, children, footerActions, showDefaultHome = true, }) => {
  const navigate = useNavigate();
  const extraActions = normalizeActions(footerActions);

  return (
    <div className="status-layout">
      <Header />
      <main className="status-main">
        <section className="status-card">
          <p className="status-eyebrow">Your E-Verify Status is</p>
          <div className="status-chip">{title}</div>
          {description && <p className="status-description">{description}</p>}
          <div className="status-content">{children}</div>
          {/* <div className="status-footer-actions">
            <button
              type="button"
              className="status-muted-button"
              onClick={() => navigate("/")}
            >
              Go to Home Page
            </button>
            {extraActions.map((action, index) => (
              <Fragment key={`status-action-${index}`}>{action}</Fragment>
            ))}
          </div> */}
          <div className="status-footer-actions">
            {showDefaultHome && (
              <button
                type="button"
                className="status-muted-button"
                onClick={() => navigate("/")}
              >
                Go to Home Page
              </button>
            )}
            {extraActions.map((action, index) => (
              <Fragment key={`status-action-${index}`}>{action}</Fragment>
            ))}
          </div>
        </section>
      </main>
      <Footer />
    </div>
  );
};

export default StatusLayout;
